<template>
  <picture>
    <source
      :srcset="desktopUrl"
      :media="`(min-width: ${MIN_DESKTOP_WIDTH}px)`"
    >
    <img
      :src="mobileUrl"
      :alt="alt"
      :title="alt"
      :itemprop="SCHEMA_ITEM_PROP.IMAGE"
      :loading="loadingMode"
      class="object-contain w-full h-full"
    >
  </picture>
</template>

<script lang="ts">

import { MIN_DESKTOP_WIDTH } from '~~/constants/ui';
import { SCHEMA_ITEM_PROP } from '~~/constants/seo';
import { getUrlWithResizeQuery } from '~~/helpers/twicpics/getUrlWithResizeQuery';
import { LOADING_MODE } from '~~/constants/images';

export default defineComponent({
  name: 'TwicpicsPicture',
  components: {

  },
  props: {
    src: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
      default: MIN_DESKTOP_WIDTH,
    },
    desktopHeight: {
      type: Number,
      required: true,
    },
    mobileHeight: {
      type: Number,
      required: true,
    },
    mode: {
      type: String,
      default: 'contain',
    },
    preload: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {

    const desktopUrl = computed(() => getUrlWithResizeQuery(props.src, {
      mode: props.mode,
      width: props.width,
      height: props.desktopHeight,
    }));
    const mobileUrl = computed(() => getUrlWithResizeQuery(props.src, {
      mode: props.mode,
      width: props.width,
      height: props.mobileHeight,
    }));

    const loadingMode = computed(
      () => props.preload ? LOADING_MODE.EAGER : LOADING_MODE.LAZY);

    const preloadLinks = computed(() => {

      if (!props.preload) {

        return [];

      }

      const links: Array<{
        key: string,
        rel: 'preload',
        as: 'image',
        href: string,
        media: string,
        fetchpriority: 'high',
      }> = [
        {
          key: `preload-image-desktop:${desktopUrl.value}`,
          rel: 'preload',
          as: 'image',
          href: desktopUrl.value,
          media: `(min-width: ${MIN_DESKTOP_WIDTH}px)`,
          fetchpriority: 'high',
        },
        {
          key: `preload-image-mobile:${mobileUrl.value}`,
          rel: 'preload',
          as: 'image',
          href: mobileUrl.value,
          media: `(max-width: ${MIN_DESKTOP_WIDTH - 1}px)`,
          fetchpriority: 'high',
        },
      ];

      return links;

    });

    useHead(() => {

      if (!props.preload) {

        return {};

      }

      return {
        link: preloadLinks.value,
      };

    });

    return {
      desktopUrl,
      mobileUrl,
      MIN_DESKTOP_WIDTH,
      SCHEMA_ITEM_PROP,
      loadingMode,
    };
  
  },
});


</script>
